export default "__VITE_ASSET__DxVtfxW0__"